import { Navigate, useLocation } from 'react-router';

const RedirectToDenied = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      state={{ from: location.pathname }}
      to="/denied"
    />
  );
};

export default RedirectToDenied;
